import React, { FC, ReactNode, useMemo } from "react";
import { GlobalAnalysisNotificationsContext } from "./context";
import UrlAnalysisMonitor from "./UrlAnalysisMonitor";
import useActiveUrlAnalyses from "./useActiveUrlAnalyses";

type GlobalAnalysisNotificationsProviderProps = {
  children: ReactNode;
};

const GlobalAnalysisNotificationsProvider: FC<
  GlobalAnalysisNotificationsProviderProps
> = ({ children }) => {
  const { activeAnalyses, addAnalysis, removeAnalysis } =
    useActiveUrlAnalyses();

  const context = useMemo(
    () => ({ activeAnalyses, addAnalysis, removeAnalysis }),
    [activeAnalyses, addAnalysis, removeAnalysis]
  );

  return (
    <GlobalAnalysisNotificationsContext.Provider value={context}>
      {children}
      {(Array.isArray(activeAnalyses) ? activeAnalyses : []).map(url => (
        <UrlAnalysisMonitor key={url} url={url} />
      ))}
    </GlobalAnalysisNotificationsContext.Provider>
  );
};

export default GlobalAnalysisNotificationsProvider;
